export const REQUEST_CLIENTIFY_FILTERS = 'CLIENTIFY_FILTERS';
export const REQUEST_CLIENTIFY_FILTERS_SUCCEEDED = 'CLIENTIFY_FILTERS_SUCCEEDED';
export const REQUEST_CLIENTIFY_FILTERS_FAILED = 'CLIENTIFY_FILTERS_FAILED';
